import { createApp } from 'vue'

// 引入vant
import { Icon, Tab, Tabs, Search, Button, Empty, Overlay, Form, Field, CellGroup, Popup } from 'vant'
import 'vant/lib/index.css';

// 引入nutui
import {  GiftBox, Hiteggs } from '@nutui/nutui-bingo'
import "@nutui/nutui-bingo/dist/style.css";

// 引入抽奖插件
import VueLuckyCanvas from '@lucky-canvas/vue'

// 引入vue-wechat-title
import VueWechatTitle from 'vue-wechat-title'

import App from './App.vue'
import router from './router'
import store from './store'

// let jweixin = require('jweixin-module')
const app = createApp(App)
// app.config.globalProperties.$wx = jweixin

app.use(Icon)
.use(Tab)
.use(Tabs)
.use(Search)
.use(Button)
.use(Empty )
.use(GiftBox)
.use(Hiteggs)
.use(Overlay)
.use(Form)
.use(Field)
.use(CellGroup)
.use(Popup)
.use(VueLuckyCanvas)
.use(VueWechatTitle)
.use(store)
.use(router)
.mount('#app')
